import { useGetOrganisationQuery } from '../../generated/core-api/graphql-react-query';
import isCancelledRequestError from '../../utils/isCancelledRequestError';

interface UseOrganisationOptions {
  enabled?: boolean;
}

export function useOrganisation(options: UseOrganisationOptions = {}) {
  const { enabled = true } = options;
  const org = useGetOrganisationQuery({}, {
    enabled,
    retry(failureCount, error) {
      return isCancelledRequestError(error) && failureCount < 3;
    },
  });
  return {
    ...org,
    ...org.data && {
      data: {
        ...org.data,
        org: {
          ...org.data.org,
          ...(!org.data.org.enableAlternativeAsrApi && !org.data.org.enableCoreAsrApi) && {
            enableCoreAsrApi: true,
            enableAlternativeAsrApi: false,
          },
        },
      },
    },
  };
}

export function useOrganisationData() {
  const org = useOrganisation();
  if (!org.data) {
    throw new Error('Organisation not loaded');
  }
  return org.data.org;
}
